import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as UsersIconSvg } from '../../assets/users-icon.svg';

export const UsersIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={UsersIconSvg} {...props} />;
};
